export default __webpack_public_path__ + "static/media/Licenses_BG-03.84147ded.png";